export default [
  {
    path: '/',
    name: 'migration',
    component: () => import('@/components/form/form-migration.vue')
  }
]